import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Col from 'react-bootstrap/Col';
import properties from '../../../modules/ajio-util/properties';
import ProductPromoOffers from './ProductPromoOffers';
import { showModal, hideModal } from '../../../actions/modal';
import PriceSavingInfoPopup from './PriceSavingInfoPopup';
import ProductUpdationPopup from './ProductUpdationPopup';
import ProductRemovalPopup from './ProductRemovalPopup';
import { getSizeDetail } from '../../actions/cart';
import { addProductToWishlist } from '../../../wishlist/actions/wishlist';
import { signInCheck } from '../../../components/common/CheckUserStatus';
import { sendEvent } from '../../../utils/dataGrinch.js';
import { getPageInfo } from '../../../utils/pageInfo.js';
import {
  calculatePriceInfo,
  getAppliedPromoFiredMsg,
  addCustomerType
} from '../../../utils/products';
import { getDateRange } from '../../../edd/utils/getDateRange.js';
import { showErrorMessageInfo } from '../../../actions/shared/HTTPError';
import deleteFromCartAndAddToWishlist from './deleteFromCartAndAddToWishlist';
import {
  IsDealStart,
  IsDealEnd
} from '../../../components/common/DodCommonComponent/DodComponentFunctionality';
import {
  DealOfTheDayTag,
  DealOfTheDayTimerTag
} from '../../../components/common/DodCommonComponent/DodCommonComponent';
import { DealOfTheDayModal } from '../../../components/common/DodCommonComponent/DodModals';
import Modal from '../../../components/common/Modal';
import { fetchSizeAndBrandSize, beautyCheck } from '../../../utils/StandardSizeUtils';
import { getNewSizeRevampFlag, getShowBrandSizeFlag } from '../../../Flags/selectors.js';
import luxeScreen from '../../../refresh/constants/luxeScreenType';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import { readCookie } from '../../../components/common/Cookie';
import { displayValueWithSymbol } from '../../../utils/price';
import { jioAdsAddtoWishList } from '../../../utils/jioAds';
import { isCatalogNameInFirebaseStore } from '../../../utils/common';
import {
  getStoresForHidingMRP,
  getEnableRating,
  getEnableRatingLabelCart,
  getGiftWithProductEnable
} from '../../../refresh/selectors/featureFlagsSelector';
import AggregatedRatingTag from '../../../refresh/atoms/AggregatedRatingTag';
import { Feature, Variant } from '../../../refresh/organism/ABFeature';
import { FreebiesProductsItems } from '../../../components/common/Freebies/FreebiesGiftCard';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { replaceWithJioCDN } from '../../../../src/utils/imageHandling';
import { isExclusiveDatePast } from '../../../../src/utils/products';

const sizeObj = {
  XXS: 'Extra Extra Small',
  XS: 'Extra Small',
  S: 'Small',
  M: 'Medium',
  L: 'Large',
  XL: 'Extra Large',
  XXL: 'Extra Extra Large',
  'S/M': 'Small-Medium',
  'M/L': 'Medium-Large',
  'L/XL': 'Large-Extra Large'
};

const imageBaseUrl = properties.getProperty('imageBaseUrl');
export function isEDDRequired(pageTitle) {
  switch (pageTitle) {
    case 'orderconfirm':
      return true;
    default:
      return false;
  }
}
export class CartProductCard extends React.Component {
  constructor(props) {
    super(props);
    this.textResources = {
      moveClosetBtn: 'Move to Wishlist'
    };
    this.state = {
      alt: '',
      header: 'One Item Per Person',
      subText: 'Sale limited to one item per person',
      giftItemData: {}
    };
  }
  handleError(event) {
    event.target.src = `${properties.getProperty('imageBaseUrl')}/static/img/plp.png`;
  }
  sendAddToWithListDataGlinch = status => {
    const productDetails = this.props.product;
    const { code, quantity, size, priceInfo = {} } = productDetails;
    const { Price, Discount, CouponSaving } = calculatePriceInfo(priceInfo);
    const eventObj = [];
    eventObj.ProductId = code;
    eventObj.quantity = quantity;
    eventObj.size = size;
    eventObj.status = status;
    eventObj.Price = Price;
    eventObj.Discount = Discount;
    eventObj.CouponSaving = CouponSaving;
    const { pageId, pageType } = getPageInfo(location.pathname || '');
    eventObj.pageId = pageId;
    eventObj.pageType = pageType;
    sendEvent('MoveToCloset', eventObj);
  };
  handleSizeChange = (sizeClick = false, beautyVolume = '', hideSizes = false) => {
    const { product = {} } = this.props;
    const { code, entryNumber, quantity = '', dealEnabled = false } = product;
    if (dealEnabled) {
      if (!sizeClick) {
        this.setState({
          ...this.state,
          header: 'One Item Per Person',
          subText: 'Sale limited to one item per person'
        });
        this.props.showModal('cart-one-item-per-person');
        return;
      }
    }
    !dealEnabled && sessionStorage.removeItem(`${code}`);
    if (sizeClick) {
      this.props.getSizeDetail(code);
      const timeout = setTimeout(() => {
        this.props.setModal({
          name: 'cart-qty',
          classes: 'cart-qty-update-modal',
          ariaLabel: "Select Size",
          content: (
            <ProductUpdationPopup
              priceInfo={product.priceInfo}
              quantity={quantity}
              entryNumber={entryNumber}
              code={code}
              updateQuantity={this.props.updateQuantity}
              modalName="cart-qty"
              dealEnabled={dealEnabled}
              beautyVolume={beautyVolume}
              hideSizes={hideSizes}
              itemData={product}
            />
          )
        });
        clearTimeout(timeout);
      }, 1000);
    } else {
      this.props.getSizeDetail(code);
      this.props.setModal({
        name: 'cart-qty',
        classes: 'cart-qty-update-modal',
        ariaLabel: "Select Size",
        content: (
          <ProductUpdationPopup
            priceInfo={product.priceInfo}
            quantity={quantity}
            entryNumber={entryNumber}
            code={code}
            updateQuantity={this.props.updateQuantity}
            modalName="cart-qty"
            beautyVolume={beautyVolume}
            hideSizes={hideSizes}
            itemData={product}
          />
        )
      });
      if (typeof ga === 'function') {
        ga('send', {
          hitType: 'event',
          eventCategory: 'Buttop tap',
          eventAction: 'Current event for clicking on "qty" button',
          eventLabel: 'Inventory change'
        });
      }
    }
  };
  addWishlistInLocal = productCode => {
    const userId = signInCheck(true);
    const wishlistData = JSON.parse(localStorage.getItem('productWishlistStatusData'));
    if (!wishlistData || !userId || productCode === '') return false;
    const userWishlistData = wishlistData[userId];
    if (!userWishlistData) return false;
    const { codes = [], updatedOn } = userWishlistData;
    if (codes.length === 0 || !codes.includes(productCode)) codes.push(productCode);
    const localData = {
      updatedOn,
      codes
    };
    const finalResponse = wishlistData;
    finalResponse[userId] = localData;
    localStorage.setItem('productWishlistStatusData', JSON.stringify(finalResponse));
  };

  freebiesItemsList = (props) => {
    const { giftItemData ={}, isLuxe=false } = props;
    const { giftQuantity=0,
      giftProducts: { quantities =[], associatedProducts=[] } ={}
    } = giftItemData;
    const productItems = quantities.map((item, i)=>{
      return {
        brandName: item.productTitle,
        imageUrl: item.image,
        mrp: item.mrp,
        quantity: item.qty,
        isReturnable: item.isReturnable
      }
    });
  
    return (
      <div>
        <div className={ `freebie-items-modal-title ${!isLuxe && 'border-bottom-freebie'}`}>{giftQuantity}{" "} Freebies</div>
        <div className='freebie-items-modal-div'>
          <FreebiesProductsItems
            products={productItems}
            isDesktop
            isLuxe={isLuxe}
          />
          {associatedProducts.length>0 && 
            <div className='associatedProducts-div'>
              <p>On completing combo purchase of</p>
              <div className='freebie-add-image-div'>
                {
                  associatedProducts.map((item)=>{
                    return(
                      <div className='freebie-add-image'>
                        <img src={replaceWithJioCDN(item?.image)} alt="product image" height="44px" width="36px"/>
                      </div>
                    )
                  })
                }
              </div>
            <div>
          </div>
          </div>}
        </div>
      </div>
    );
  };

  render() {
    const {
      product = {},
      idx = '',
      isPageTitle = false,
      orderPageTitle = '',
      itemAvailabilty = {},
      newSizeRevampFlag,
      showBrandSizeFlag,
      appliedPromoFiredMsg = '',
      storesForHidingMRP,
      enableRating,
      enableRatingLabelCart,
      deliveryFeeTagInfo = {},
      displayDeliveryFeeTag = false,
      changeModalViewState,
      enableGiftWithProductFlag=false,
      isLuxe=false
    } = this.props;
    const {
      brandName = '',
      code,
      catalogName,
      entryNumber,
      exclusiveTill = '',
      productTag = '',
      images = [],
      offers = {},
      name = '',
      priceInfo = {},
      quantity = '',
      size = '',
      brandSize = '',
      url,
      offers: { listVoucher = 0 } = {},
      altText,
      voucherMessages = '',
      baseProduct = '',
      eddUpper,
      eddLower,
      basePrice = {},
      dealEnabled = false,
      dealEndTime,
      dealType,
      actualDealStartTime,
      premiumDealStartTime,
      variantOptionQualifiers,
      brickCategory,
      averageRating,
      numUserRatings,
      brickSubCategory,
      brickName,
      isGiftProduct = false,
      giftQuantity=0,
      giftProducts: { quantities =[], associatedProducts=[] } ={}
    } = product;
    const { valueWithUnit: volume, hideSizes } = beautyCheck(variantOptionQualifiers);
    const productTagValue = isExclusiveDatePast(exclusiveTill)
      ? 'EXCLUSIVE'
      : productTag?.toLowerCase() !== 'exclusive'
      ? productTag
      : '';
    const { sizeUI: newSizeUI = '', brandSizeUI: newBrandSize = '' } = fetchSizeAndBrandSize(
      variantOptionQualifiers,
      newSizeRevampFlag
    );

    const brandSizeUI = showBrandSizeFlag ? newBrandSize || brandSize : '';
    const sizeUI = newSizeUI || size;
    
    function manageSizeName(tempSize) {
      if (sizeObj[tempSize]) {
        return sizeObj[tempSize];
      }
      return null;
    };

    function extractRange(tempSize) {

      // Match N followed by Y or M (e.g., "2Y" or "3M")
      let matchSingle = tempSize.match(/^(\d+)([YM])$/);
      // Match N-N followed by Y or M (e.g., "0-3Y" or "1-5M")
      let matchRange = tempSize.match(/^(\d+)-(\d+)([YM])$/);
      const unitMap = {
        Y: "year",
        M: "month"
      };

      if (matchSingle) {
        return {
          start: parseInt(matchSingle[1], 10),
          unit: unitMap[matchSingle[2]], // "Y" or "M"
        };
      }

      if (matchRange) {
        return {
          start: parseInt(matchRange[1], 10),
          end: parseInt(matchRange[2], 10),
          unit: unitMap[matchRange[3]], // "Y" or "M"
        };
      }

      // Not a valid format
      return null;
    }
    const sizeAriaLabel = extractRange(sizeUI)
    const sizeAriaLabel2 = manageSizeName(sizeUI)
    
    const {
      discountPercentage = '',
      originalPrice = '',
      netPrice = '',
      totalSaving = '',
      couponSaving = ''
    } = priceInfo;
    const itemAvailable =
      itemAvailabilty.availableQuantity < quantity ? itemAvailabilty.availableQuantity : false;
    let imageRender;
    if (images.length) {
      imageRender = images.map((imageData, i) => {
        if (imageData.format == 'mobileProductListingImage') {
          return (
            <Fragment>
              <img
                src={`${replaceWithJioCDN(imageData.url)}`}
                key={i}
                alt={imageData.altText || altText}
                title={imageData.altText || altText}
                onError={this.handleError}
              />

              {enableGiftWithProductFlag && isGiftProduct && <img style={{
                position: "absolute",
                bottom: "-69px",
                width: "36px",
                left: "-4px",
              }} src={`${imageBaseUrl}/static/img/${isLuxe ? 'FreeTagLuxe.svg' : 'FreeTag.svg'}`} alt="Free Tag" />}
            </Fragment>
          );
        }
        if (imageData.format == 'PRIMARY') {
          return (
            <Fragment>
              <img
                src={`${replaceWithJioCDN(imageData.url)}`}
                key={i}
                alt={imageData.altText || altText}
                title={imageData.altText || altText}
                onError={this.handleError}
              />
              {enableGiftWithProductFlag && isGiftProduct && <img style={{
                position: "absolute",
                bottom: "-69px",
                width: "36px",
                left: "-4px",
              }} src={`${imageBaseUrl}/static/img/${isLuxe ? 'FreeTagLuxe.svg' : 'FreeTag.svg'}`} alt="Free Tag" />}</Fragment>
            );
        }
      });
    } else {
      imageRender = (
        <img
          src={`${properties.getProperty('imageBaseUrl')}/static/img/plp.png`}
          key="broken-img"
          alt={altText}
          title={altText}
        />
      );
    }
    const isSignedIn = signInCheck();
    const { appliedVouchers = [], potentialPromotion = {}, appliedPromotion = {} } = offers;
    const potentialPromotionsTemp = potentialPromotion;
    const qtyClass = itemAvailable ? 'cartqty warning' : 'cartqty';
    const { deviceType = '', addToWishlistApi, deleteCard, showErrorMessageInfo } = this.props;
    const dateRange = getDateRange({ eddLower, eddUpper });
    // Deal of the Day
    const { isDealStart = false } =
      dealEnabled && actualDealStartTime ? IsDealStart(actualDealStartTime) : false;
    const { isDealEnd = true } = dealEnabled && dealEndTime ? IsDealEnd(dealEndTime) : false;
    const { confirmPageUrl = '', dealInventory = '' } = this.props;
    const isConfirmPage = confirmPageUrl.indexOf('/confirm') !== -1;
    const dodCartTimer =
      dealEnabled && isDealStart && !isDealEnd && !isConfirmPage ? (
        <div className="dodCartTimer">
          <div className="dodCartItemLeft">
            {dealInventory && dealInventory <= 20 ? `Only ${dealInventory} Item(s) left` : ' '}
          </div>
          <DealOfTheDayTimerTag
            dealOfTheDayProductTimer={dealEndTime}
            imagePath="/static/img/endsIn.png"
            isCartTimeOut
            showModal={this.props.showModal}
            modalName="cart-dod-time-up"
            alt="Timer icon"
          />
        </div>
      ) : (
        ''
      );
    let dealSessionData = {};
    let showPriceIncreaseMessage = false;
    let priceIncrease = '';
    if (dealEnabled && isDealStart && !isDealEnd) {
      dealSessionData = {
        dealPrice: netPrice.value,
        code
      };
      if (window.sessionStorage) {
        window.sessionStorage.setItem(`${code}`, JSON.stringify(dealSessionData));
      }
    } else if (window.sessionStorage) {
      const dealCartSessionPrice = JSON.parse(window.sessionStorage.getItem(`${code}`)) || {};
      const { code: sessionCode = '', dealPrice = '' } = dealCartSessionPrice;
      if (code === sessionCode) {
        if (dealPrice < netPrice.value) {
          showPriceIncreaseMessage = true;
          priceIncrease = netPrice.value - dealPrice;
          priceIncrease = Number.isInteger(priceIncrease)
            ? `${priceIncrease}.00`
            : parseFloat(priceIncrease).toFixed(2);
        }
      }
    }
    const priceChangeDOM = showPriceIncreaseMessage ? (
      <div className="priceIncDec">
        <div className="priceIncDec__icon">
          <span className="ic-PriceIncrease" />
        </div>
        <div className="priceIncDec__message">
          Price increase {displayValueWithSymbol(priceIncrease)}
        </div>
      </div>
    ) : null;
    const { newDesignLuxe } = this.props;
    const { handleGtmEvent } = this.props;
    {
      newDesignLuxe ? (this.textResources.moveClosetBtn = 'Move to Wishlist') : ' ';
    }
    const { cart: { screenType = '', screenName = '' } = {}, luxeStore = '' } = luxeScreen;
    const hideMRP = isCatalogNameInFirebaseStore(storesForHidingMRP, catalogName);
    const { deliveryFeeTag = '', isItemWithFreeDelivery = false } = deliveryFeeTagInfo;
    return (
        <div className="card-offer">
          <Modal
            name="cart-one-item-per-person"
            className="dodModal"
            closeButton={false}
            disableOutsideClick
          >
            <DealOfTheDayModal
              alt='Error icon'
              logo="/static/img/modalFail.png"
              header={this.state.header}
              subText={this.state.subText}
              modalName="cart-one-item-per-person"
              hideModal={this.props.hideModal}
            />
          </Modal>
          <Modal name="cart-dod-time-up" closeButton={false} disableOutsideClick className="dodModal">
            <DealOfTheDayModal
              alt="Timer icon"
              logo="/static/img/timer.png"
              header="Time is up"
              timer
              subText="Sorry, deal is over. Although you can buy this product on an updated price"
              isStartIn={false}
              topTimerOrProductTimer={false}
              pageRefresh
              modalName="cart-dod-time-up"
            />
          </Modal>
          <div className={enableGiftWithProductFlag && giftQuantity> 0? 'freebies-cart-items-container' : ''}>
            {!orderPageTitle &&
            appliedVouchers
              .concat(Object.keys(potentialPromotion))
              .concat(Object.keys(appliedPromotion)).length > 0 ? (
              <ProductPromoOffers
                isPageTitle={isPageTitle}
                voucherMessages={voucherMessages}
                offers={offers}
                listVoucher={listVoucher}
                setModal={this.props.setModal}
                priceInfo={priceInfo}
                appliedPromoFiredMsg={appliedPromoFiredMsg}
              />
            ) : (
              ''
            )}

            {enableGiftWithProductFlag && giftQuantity> 0 && <div className='freebies-cart-items-text-block' onClick={()=>changeModalViewState(true, product)}>
                <img src={`${properties.getProperty('imageBaseUrl')}/static/img/freebie-gift${isLuxe ? '-luxe': ''}.svg`} alt={"freebie icon"} height= {"20px"} width={"20px"}/>
                <div className={isLuxe ? 'freebie-text-luxe' :'freebie-text'}>{giftQuantity === 1 ? 'Freebies' : `${giftQuantity} Freebies` }</div>
                <img src={`${properties.getProperty('imageBaseUrl')}/static/img/forward-vector.svg`} alt={"forward-vector"} height= {"20px"} width={"20px"}/>
            </div>}
          </div>
  
          <Modal
            name="freebies-cart-modal"
            closeButton
            onClose={()=>changeModalViewState(false)}
            customClassName={"modal-bg-color"}
            alignToRight
            fullHeight
          >
              {this.freebiesItemsList({...product, giftItemData: this.props.giftItemData, isLuxe})}
          </Modal>

          {dodCartTimer}
          <div className="product-card">
            {itemAvailable && deviceType === 'msite' && (
              <div className="oos-qty">
                <span>
                  Please update the quantity. Only
                  {itemAvailable} left in stock
                </span>
              </div>
            )}
            <input type="hidden" name={`baseProductId_${idx}`} value={baseProduct} />
            <div className="card-section row">
            <Col xs={4} lg={2} className="product-img" aria-hidden="true">
              <a href={addCustomerType(url)} aria-hidden="true" tabIndex={-1}>
                  {imageRender}
                  {productTagValue ? (
                    <div className="product-exclusive" aria-label={productTagValue}>{productTagValue}</div>
                  ) : null}
                </a>
              </Col>
              <Col xs={8} lg={10} className="product-details">
                <div className="product-name">
                  {newDesignLuxe && orderPageTitle === 'orderconfirm' ? (
                    <a href={addCustomerType(url)} aria-label={`${brandName} ${name}${volume ? ' | ' + volume : ''}`}>
                      <div className="mb-2" aria-label={brandName}>{brandName}</div>
                      <div aria-label={`${name}${!!volume ? "| " + volume : ""}`}>
                        {name}
                        {volume ? ` | ${volume}` : ''}
                      </div>
                    </a>
                  ) : (
                    <div>
                      <a href={addCustomerType(url)} aria-label={`${brandName} ${name}${volume ? ' | ' + volume : ''}`}>
                        <span>{brandName}</span> -{name}
                        {volume ? ` | ${volume}` : ''}
                      </a>
                      {enableRating && averageRating && enableRatingLabelCart && (
                        <AggregatedRatingTag
                          ratingValue={averageRating}
                          totalRatingCount={numUserRatings}
                          customClass="rating-label-desktop-cart"
                          backGroundColour={averageRating < 3 ? 'red' : 'green'}
                          size="lg"
                        />
                      )}
                    </div>
                )}
                  {displayDeliveryFeeTag && (
                    <div
                      className={
                        newDesignLuxe || !isItemWithFreeDelivery
                          ? 'delivery-fee-tag'
                          : 'delivery-fee-tag free-delivery'
                      }
                    >
                      {deliveryFeeTag}
                    </div>
                  )}
                </div>
                <div className="update-wrapper">
                  {!orderPageTitle && !volume && !hideSizes ? (
                    <div
                      className="cartsize"
                      onClick={() => this.handleSizeChange(true)}
                      role="button"
                      tabIndex={0}
                    >
                      <span aria-label="Size">Size</span>
                      <div>
                        <span aria-label={sizeAriaLabel2 ? sizeAriaLabel2 : sizeAriaLabel ? `${sizeAriaLabel?.start}  ${sizeAriaLabel?.end ? 'to ' + sizeAriaLabel?.end : '' } ${sizeAriaLabel?.unit}` : sizeUI}><span aria-hidden="true">{sizeUI}</span></span>
                        {brandSizeUI ? (
                          <span id="brand-size" aria-label={`Brand Size ${brandSizeUI}`}>
                            (Brand Size <span className="size-format">{brandSizeUI}</span>)
                          </span>
                        ) : null}
                        <span className="ic-chevrondown" />
                      </div>
                    </div>
                  ) : (
                    <div className="cartsize">
                      {!!volume || hideSizes ? (
                        ''
                      ) : (
                        <span
                          className={newDesignLuxe && deviceType !== 'msite' && 'cartsize-grayspan'}
                          aria-label="Size"
                        >
                          Size
                        </span>
                      )}
                      {!!volume || hideSizes ? (
                        ''
                      ) : (
                        <div>
                          {sizeUI}
                          {brandSizeUI ? (
                            <span id="brand-size" aria-label={`Brand Size ${brandSizeUI}`}>
                              (Brand Size <span className="size-format">{brandSizeUI}</span>)
                            </span>
                          ) : null}
                        </div>
                      )}
                    </div>
                  )}
                  {!orderPageTitle ? (
                    <div
                      className={qtyClass}
                      onClick={() => this.handleSizeChange(false, volume, hideSizes)}
                      role="button"
                      tabIndex={0}
                    >
                      <span aria-label="Qty">Qty</span>
                      <div>
                        {quantity}
                        <span className="ic-chevrondown" />
                      </div>
                    </div>
                  ) : (
                    <div className={qtyClass}>
                      <span
                        className={newDesignLuxe && deviceType !== 'msite' && 'cartsize-grayspan'}
                        aria-label="Qty"
                      >
                        Qty
                      </span>
                      <div> {quantity}</div>
                    </div>
                  )}
                  {itemAvailable && deviceType !== 'msite' && (
                    <div className="oos-qty">
                      <span aria-label={`Please update the quantity. Only ${itemAvailable} left in stock`}>
                        Please update the quantity. Only
                        {itemAvailable} left in stock
                      </span>
                    </div>
                  )}
                </div>
              {!orderPageTitle && totalSaving.value > 0 && hideMRP ? (
                <Col
                  xs={12}
                  className={`product-saving ${dealEnabled &&
                    'addTopDueToDod'}`}
                  onClick={() => {
                    this.props.setModal({
                      name: 'product-saving',
                      classes: 'product-saving-modal',
                      content: <PriceSavingInfoPopup product={product} />,
                      ariaLabel: "Savings"
                    });
                  }}
                  role="button"
                  tabIndex={0}
                >
                  Savings :
                  <span className="cart-total-saving-text">
                    <strong>{totalSaving.formattedValue} </strong>
                    <span className="ic-chevrondown" />
                  </span>

                </Col>
              ) : null}
                {!dealEnabled ? priceChangeDOM : null}
                {!dealEnabled ? (
                <div
                  className="priceinfo"
                >
                  <div
                    aria-label={
                      parseInt(discountPercentage) > 0 && hideMRP
                        ? `${displayValueWithSymbol(originalPrice.formattedValue)} strike off; ` +
                        `${parseInt(discountPercentage)}% discount available, ` +
                        `current price ${displayValueWithSymbol(netPrice.formattedValue)}.`
                        : `${displayValueWithSymbol(netPrice.formattedValue)}.`
                    }
                  >
                    {parseInt(discountPercentage) > 0 && hideMRP ? (
                      <div className="priceinfo-top" aria-hidden='true' tabIndex={-1}>
                        <div className="orignal-price">
                          {!newDesignLuxe && !orderPageTitle
                            ? originalPrice.formattedValue
                            : displayValueWithSymbol(originalPrice.formattedValue)}
                        </div>
                        {discountPercentage ? (
                          <>
                            {newDesignLuxe ? (
                              <div className="discount">({parseInt(discountPercentage)}% OFF)</div>
                            ) : (
                              <div className="discount">
                                ({parseInt(discountPercentage)}
                                %)
                              </div>
                            )}
                          </>
                        ) : null}
                      </div>
                    ) : null}
                    {Object.keys(potentialPromotion).length < 1 ? (
                      <div className="net-price best-price-strip" aria-hidden='true' tabIndex={-1}>
                        <strong>
                          {!newDesignLuxe && !orderPageTitle
                            ? netPrice.formattedValue
                            : displayValueWithSymbol(netPrice.formattedValue)}
                        </strong>
                      </div>
                    ) : (
                        <div className="net-price" aria-hidden='true' tabIndex={-1}>
                        <strong>
                          {!newDesignLuxe && !orderPageTitle
                            ? netPrice.formattedValue
                            : displayValueWithSymbol(netPrice.formattedValue)}
                        </strong>
                      </div>
                    )}
                  </div>
                </div>
                ) : (
                  ''
                )}
              {!orderPageTitle && (
                <div
                  className={`product-delete ${isLuxe ? 'luxe-product-delete' : ''}`}
                  onClick={() => {
                    this.props.setModal({
                      name: 'cart-delete',
                      classes: 'cart-delete-modal',
                      content: (
                        <ProductRemovalPopup
                          product={product}
                          entryNumber={entryNumber}
                          code={code}
                          deleteCard={this.props.deleteCard}
                          addToCloset={this.props.addToWishlistApi}
                          modalName="cart-delete"
                          deviceType={deviceType}
                          newDesignLuxe={newDesignLuxe}
                          position={idx}
                          enableGiftWithProductFlag={enableGiftWithProductFlag}
                          isLuxe={isLuxe}
                        />
                      ),
                      ariaLabel: 'Delete from bag'
                    });
                  }}
                  role="button"
                  tabIndex={0}
                >
                  {isPageTitle ? (
                    <div className="delete-btn" aria-label={newDesignLuxe ? 'Remove' : 'Delete'}>{newDesignLuxe ? 'Remove' : 'Delete'}</div>
                  ) : (
                    <span className="ic-delete" />
                  )}
                </div>
              )}
                {isPageTitle && (
                  <div
                    className={newDesignLuxe ? 'save-closet-btn' : 'save-closet-btn wishlist-icon-mr'}
                    onClick={() => {
                      if (isSignedIn) {
                        deleteFromCartAndAddToWishlist(
                          addToWishlistApi,
                          deleteCard,
                          'cart-delete',
                          code,
                          entryNumber,
                          showErrorMessageInfo,
                          '',
                          idx
                        );
                        newDesignLuxe &&
                          gtmEventPush({
                            event: 'Move_to_wishlist',
                            event_category: 'bag interactions',
                            event_action: 'move to wishlist',
                            event_label: readCookie('C'),
                            store_type: luxeStore,
                            page_type: screenType
                          });
                        this.addWishlistInLocal(baseProduct);
                        console.log("TRACK POINT 3 ~ brickSubCategory:", brickSubCategory)
                        console.log("TRACK POINT 3 ~ brickName:", brickName)
                        jioAdsAddtoWishList({
                          brickCategory: brickCategory || '',
                          brickSubCategory: brickSubCategory || '',
                          brickName: brickName || '',
                          code: baseProduct,
                          price: basePrice?.value,
                          quantity: 1
                        });
                      } else {
                        this.props.showModal('sign-in-up');
                      }
                    }}
                    role="button"
                    tabIndex={0}
                  >
                    {!newDesignLuxe ? (
                      <span className="wishlist-icon-mr">
                        <img src={`${imageBaseUrl}/static/img/my-bag-wishlist-icon.svg`} alt='Wishlist icon'/>
                      </span>
                    ) : (
                      <span className="ic-wishlist" />
                    )}
                    {this.textResources.moveClosetBtn}
                  </div>
                )}
                {dealEnabled ? (
                  <div className="dodCartPrice">
                    <div className="dodCartPrice-section">
                      {parseInt(discountPercentage) > 0 ? (
                        <div className="dodCartPrice-discount">
                          ({parseInt(discountPercentage)}
                          %)
                        </div>
                      ) : null}
                      <div className="dodCartPrice-original-price">
                        {displayValueWithSymbol(originalPrice.formattedValue)}
                      </div>
                    </div>
                    <div className="dodCart-finalPrice" aria-label="Deal Price:">
                      Deal Price: <span> {displayValueWithSymbol(netPrice.formattedValue)}</span>
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </Col>
              {isEDDRequired(orderPageTitle) && dateRange && (
                <Col xs={12} className="estimated-time" aria-label={`Expected Delivery: ${dateRange}`}>
                  Expected Delivery:{' '}
                  <span className="estimated-time__date">
                    <strong>{dateRange}</strong>
                  </span>
                </Col>
              )}
          </div>
          </div>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const { flags = {}, cart: { appliedProductPromotions = [] } = {} } = state;
  const { product: { entryNumber = -1, multiItemPromoAmt = 0 } = {} } = ownProps;
  const appliedPromoFiredMsg = getAppliedPromoFiredMsg(
    appliedProductPromotions,
    entryNumber,
    multiItemPromoAmt
  );
  const enableGiftWithProductFlag = getGiftWithProductEnable(flags);
  const isLuxe = getCurrentStore(state) === 'luxe';

  return {
    newSizeRevampFlag: getNewSizeRevampFlag(flags),
    showBrandSizeFlag: getShowBrandSizeFlag(flags),
    appliedPromoFiredMsg,
    storesForHidingMRP: getStoresForHidingMRP(state),
    enableRating: getEnableRating(flags,state),
    enableRatingLabelCart: getEnableRatingLabelCart(state) === 'ON',
    appliedPromoFiredMsg,
    enableGiftWithProductFlag,
    isLuxe
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    },
    showErrorMessageInfo: error => {
      dispatch(showErrorMessageInfo(error));
    },
    getSizeDetail: code => {
      dispatch(getSizeDetail(code));
    },
    addToWishlistApi: (productId, showMessage) =>
      dispatch(addProductToWishlist(productId, showMessage))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CartProductCard);